// marketing–module.js
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLocation } from "react-router-dom";
import { useScrollBehavior } from './useScrollBehavior.js'; 
import { Link } from 'react-router-dom';
import './marketing_module.css';

const ModuleOneHalf = ({ renderAnimatedLettersByWord }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.35 });
  const location = useLocation();

  useScrollBehavior();

  const container = {
    hidden: { opacity: 0, y: 18 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut", staggerChildren: 0.12 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 14 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
  };

  

  return (
    <div id="mod1half_wrap" ref={ref}>
      {/* LEFT */}
      <motion.div
        id="mod1half_left"
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={container}
      >
        <motion.div id="mod1half_kicker" variants={item}>
          24/7 Lead Capture • Faster Replies • Higher Conversion • Less Missed Revenue
        </motion.div>

        <motion.h1 id="mod1half_h1" variants={item}>
          {renderAnimatedLettersByWord(
            "An AI chatbot that turns website traffic into booked calls.",
            inView
          )}
        </motion.h1>

        <motion.p id="mod1half_p" variants={item}>
          Most sites lose leads because nobody answers fast enough. We build chatbots that respond
          instantly, qualify prospects, capture contact details, and route high-intent leads to the
          right next step — booking, calling, or requesting a quote.
        </motion.p>

        <motion.div id="mod1half_ctaRow" variants={item}>
          <Link
            to="/pricing#moduleChatbotPackages"
            id="mod1half_ctaPrimary"
            >
            View Chatbot Pricing
          </Link>
         

          <div id="mod1half_ctaNote">
            <div className="mod1half_noteTop">Production-ready delivery</div>
            <div className="mod1half_noteBottom">Secure setup • Measurable results • Ongoing optimization</div>
          </div>
        </motion.div>
        <div id="chatbot_img"></div>
      </motion.div>

       

      {/* RIGHT */}
      <motion.div
        id="mod1half_right"
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={container}
      >
        <motion.div className="mod1half_tile" variants={item}>
          <div className="mod1half_tileTitle">24/7 instant response</div>
          <div className="mod1half_tileBody">
            Answer questions, reduce drop-offs, and capture leads even when you’re busy or closed.
          </div>
        </motion.div>

        <motion.div className="mod1half_tile" variants={item}>
          <div className="mod1half_tileTitle">Lead qualification + routing</div>
          <div className="mod1half_tileBody">
            Qualifies intent, collects key details, and sends the right leads to email/SMS/CRM.
          </div>
        </motion.div>

        <motion.div className="mod1half_tile" variants={item}>
          <div className="mod1half_tileTitle">Booking + quote workflow</div>
          <div className="mod1half_tileBody">
            Push users to the next step: schedule a call, request a quote, or start an intake.
          </div>
        </motion.div>

        <motion.div className="mod1half_tile" variants={item}>
          <div className="mod1half_tileTitle">Reporting you can act on</div>
          <div className="mod1half_tileBody">
            Track conversations, lead volume, common objections, and conversion opportunities.
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ModuleOneHalf;


